<template>
    <div class="modal fade" :id="id" tabindex="-1">
      <div class="modal-dialog modal-lg" >
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('appointments.do_report') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
            <div class="modal-body scroll-y" style="max-height: 75vh">
                <Input
                    :name="`${id}-subject`"
                    :is-required="false"
                    labelClass="form-label fs-6 text-black"
                    :label="$t('appointments.label.subject_rdv')"
                    :placeholder="$t('appointments.label.subject_rdv')"
                    v-model="formData.title"
                    :is-disabled="true"
                />
                <CKEditor
                    :id="`${id}_ck_editor`"
                    :required="false"
                    :content="formData.note"
                    @text="getNote"
                    containerClass="row mb-5"
                    />
                <br>
                <DropFileZone
                    :id="`${id}_upload_file`"
                    :files="formData.files"
                    @addFiles="addFiles"
                    @removeFiles="removeFiles"
                />
            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
<script setup>
import {ref, defineEmits, defineProps, watch} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import CKEditor from "@/components/CKEditor.vue";
  import DropFileZone from "@/components/DropFileZone.vue";
  
  const store = useStore()
  
  const emits = defineEmits(['load'])
  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    appointmentData: {
      type: Object,
      default: {
        title: '',
        appointment_id: '',
        note: '',
        start_time: '',
        files: [],
        detach_files: [],
        appointment_note_id: ''
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: []
    }
  })

  const isLoading = ref(false)

  const formData = ref(props.appointmentData)

watch(() => props.appointmentData, (newValue) => {
  formData.value = newValue
}, {immediate: true})

  function addFiles(files){
    if( !formData.value.files?.length) formData.value.files = []
    if( !formData.value.detach_files?.length) formData.value.detach_files = []
    for(let file of files) {
      formData.value.files.push(file)
    }
  }

  function removeFiles(index) {
    const fileToDelete = formData.value.files.splice(index, 1)
    formData.value.detach_files.push(fileToDelete[0]?.id)
  }

  function closeModal(){
      $('#'+props.id).modal('toggle')
  }

  function getNote(text) {
    formData.value.note = text
  }

  function submitForm(){
    isLoading.value = true
    if(props.isEdit){
      formData.value.files= formData.value.files.filter(file => file instanceof File)
      store.dispatch('appointments/updateNoteAppointment', formData.value)
          .then(res => {
            emits('load')
            closeModal()
              window.toastr['success'](i18n.global.t("notification.report_updated"))
              formData.value.note = ''
              isLoading.value = false
              formData.value.detach_files = []
          })
          .catch((err) => {
            isLoading.value = false
          })
    }else{
      store.dispatch('appointments/addNoteAppointment', formData.value)
        .then((response) => {
            emits('load')
            closeModal()
            isLoading.value = false
            window.toastr['success'](i18n.global.t('notification.report_created'))
            formData.value.note = ''
            formData.value.detach_files = []
          })
        .catch(err => {
          isLoading.value = false
        })
    }
  }
  </script>
  
  <style scoped></style>
  